module.exports = "<ng-container *ngIf='!forDisplay'>\n  <i *ngFor='let n of range; let $index = index;' class='fa to-rate' (click)='mark($index)' [ngClass]='isMarked($index)'></i>\n</ng-container>\n<ng-container *ngIf='forDisplay'>\n  <i *ngFor='let n of range; let $index = index;' class=\"to-display fa\" [ngClass]='isMarked($index)'></i>\n</ng-container>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/star-rating/star-rating.component.html
// module id = 971
// module chunks = 0